export const apiConst = {
  BASEURL: process.env.NEXT_PUBLIC_API_BASE_URL,
};

export const TAGS = {
  cart: "cart",
  WISHLIST: "wishlist",
  ORDERS: "orders",
  ADDRESS: "address",
  CUSTOMER: "customer",
  REVIEWS: "reviews",
};

export const PAGE_LIMIT = 12;

export const CURRENCY_CODE = "SAR";

export const COUNTRY_CODE = "SA";
